import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "booking-view personal-data" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "person-data-list" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = { class: "space-wrapper" }
const _hoisted_11 = { class: "modal flight-details person-info" }
const _hoisted_12 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_EasyDrop = _resolveComponent("EasyDrop")!
  const _component_InfoForm = _resolveComponent("InfoForm")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", null, [
        _createElementVNode("header", null, [
          _createElementVNode("h2", null, _toDisplayString(_ctx.pageTexts["hotelPagePersonalInformationStepHeadlineConfirm"]), 1),
          _createElementVNode("div", null, [
            _createVNode(_component_router_link, {
              class: "back-btn",
              title: _ctx.pageTexts['hotelPageNavigationButtonPrevious'],
              to: { name: 'personal-data', query: _ctx.query }
            }, null, 8, ["title", "to"]),
            (_ctx.pageTexts['hotelPagePersonalInformationStepInfoPopupConfirm'])
              ? (_openBlock(), _createBlock(_component_EasyDrop, {
                  key: 0,
                  dropdownType: 'tooltip',
                  position: 'right'
                }, {
                  content: _withCtx(() => [
                    _createElementVNode("div", {
                      class: "rte",
                      innerHTML: 
                  _ctx.pageTexts['hotelPagePersonalInformationStepInfoPopupConfirm']
                
                    }, null, 8, _hoisted_2)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("ul", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formPersons, (person, index) => {
            return (_openBlock(), _createElementBlock("li", { key: index }, [
              _createElementVNode("article", null, [
                _createElementVNode("header", null, [
                  _createElementVNode("h2", null, [
                    (person.isAdult)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.pageTexts["hotelPagePersonalInformationStepLabelAdult"]), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.pageTexts["hotelPagePersonalInformationStepLabelChild"]), 1)),
                    _createTextVNode("  " + _toDisplayString(person.personTypeIndex + 1), 1)
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "link-btn",
                    onClick: ($event: any) => (_ctx.openEditModal(person))
                  }, _toDisplayString(_ctx.pageTexts["hotelPagePersonalInformationStepLabelEdit"]), 9, _hoisted_6)
                ]),
                _createElementVNode("dl", null, [
                  _createElementVNode("dt", null, [
                    _createTextVNode(_toDisplayString(_ctx.pageTexts["hotelPagePersonalInformationStepLabelFirstname"]) + " ", 1),
                    _createElementVNode("small", null, _toDisplayString(_ctx.pageTexts["hotelPagePersonalInformationStepLabelAsInPassport"]), 1)
                  ]),
                  _createElementVNode("dd", null, _toDisplayString(person.searchPerson.firstName), 1),
                  (person.searchPerson.middleName)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("dt", null, [
                          _createTextVNode(_toDisplayString(_ctx.pageTexts["hotelPagePersonalInformationStepLabelMiddlename"]) + " ", 1),
                          _createElementVNode("small", null, _toDisplayString(_ctx.pageTexts[
                      "hotelPagePersonalInformationStepLabelAsInPassport"
                    ]), 1)
                        ]),
                        _createElementVNode("dd", null, _toDisplayString(person.searchPerson.middleName), 1)
                      ], 64))
                    : _createCommentVNode("", true),
                  _createElementVNode("dt", null, [
                    _createTextVNode(_toDisplayString(_ctx.pageTexts["hotelPagePersonalInformationStepLabelLastname"]) + " ", 1),
                    _createElementVNode("small", null, _toDisplayString(_ctx.pageTexts["hotelPagePersonalInformationStepLabelAsInPassport"]), 1)
                  ]),
                  _createElementVNode("dd", null, _toDisplayString(person.searchPerson.lastName), 1),
                  _createElementVNode("dt", null, [
                    _createTextVNode(_toDisplayString(_ctx.pageTexts["hotelPagePersonalInformationStepLabelGender"]) + " ", 1),
                    _createElementVNode("small", null, _toDisplayString(_ctx.pageTexts["hotelPagePersonalInformationStepLabelAsInPassport"]), 1)
                  ]),
                  _createElementVNode("dd", null, _toDisplayString(person.searchPerson.gender?.name), 1),
                  _createElementVNode("dt", null, _toDisplayString(_ctx.pageTexts["hotelPagePersonalInformationStepLabelBirthdate"]), 1),
                  (person.searchPerson.birthdate)
                    ? (_openBlock(), _createElementBlock("dd", _hoisted_7, _toDisplayString(_ctx.formatDate(person.searchPerson.birthdate)), 1))
                    : _createCommentVNode("", true),
                  (
                  person.isAdult &&
                  person.hotelRoomIndex === 0 &&
                  person.personTypeIndex === 0
                )
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _createElementVNode("dt", null, _toDisplayString(_ctx.pageTexts["hotelPagePersonalInformationStepLabelAddress"]), 1),
                        _createElementVNode("dd", null, [
                          _createTextVNode(_toDisplayString(person.searchPerson.street), 1),
                          _hoisted_8,
                          _createTextVNode(" " + _toDisplayString(person.searchPerson.postal) + " " + _toDisplayString(person.searchPerson.city), 1),
                          _hoisted_9,
                          _createTextVNode(" " + _toDisplayString(person.searchPerson.country?.name), 1)
                        ]),
                        _createElementVNode("dt", null, _toDisplayString(_ctx.pageTexts[
                      "hotelPagePersonalInformationStepLabelContactInfoPhone"
                    ]), 1),
                        _createElementVNode("dd", null, _toDisplayString(person.searchPerson.phone), 1),
                        _createElementVNode("dt", null, _toDisplayString(_ctx.pageTexts[
                      "hotelPagePersonalInformationStepLabelContactInfoEmail"
                    ]), 1),
                        _createElementVNode("dd", null, _toDisplayString(person.searchPerson.email), 1)
                      ], 64))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_router_link, {
            class: _normalizeClass(["btn-primary", { disabled: !_ctx.isAllPersonalDataValid }]),
            to: { name: 'travel-overview', query: _ctx.query }
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.pageTexts["hotelPageNavigationButtonNext"]), 1)
            ]),
            _: 1
          }, 8, ["class", "to"]),
          _createVNode(_component_router_link, {
            class: "prev",
            to: { name: 'personal-data', query: _ctx.query }
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.pageTexts["hotelPageNavigationButtonPrevious"]), 1)
            ]),
            _: 1
          }, 8, ["to"])
        ])
      ])
    ]),
    _createVNode(_component_Modal, {
      modelValue: _ctx.showModal,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showModal) = $event)),
      close: _ctx.closeModal,
      onBeforeEnter: _ctx.fixBody,
      onAfterLeave: _ctx.unfixBody
    }, {
      default: _withCtx(() => [
        _createElementVNode("section", _hoisted_11, [
          _createElementVNode("header", null, [
            _createElementVNode("button", {
              class: "close-btn",
              title: _ctx.pageTexts['hotelPageGeneralModalButtonClose'],
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
            }, null, 8, _hoisted_12)
          ]),
          (_ctx.modalPerson)
            ? (_openBlock(), _createBlock(_component_InfoForm, {
                key: 0,
                person: _ctx.modalPerson,
                adultsCount: _ctx.adultsCount,
                childrenCount: _ctx.childrenCount,
                countries: _ctx.searchBookingOverview.countries,
                genders: _ctx.searchBookingOverview.genders,
                isContactPerson: 
          _ctx.modalPerson.isAdult &&
          _ctx.modalPerson.hotelRoomIndex === 0 &&
          _ctx.modalPerson.personIndex === 0
        ,
                pageTexts: _ctx.pageTexts,
                localeStrings: _ctx.localeStrings,
                onSetCurrentPersonValid: _ctx.setCurrentPersonValid
              }, null, 8, ["person", "adultsCount", "childrenCount", "countries", "genders", "isContactPerson", "pageTexts", "localeStrings", "onSetCurrentPersonValid"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "close", "onBeforeEnter", "onAfterLeave"])
  ], 64))
}